<script setup lang="ts">
import { IconAlert, IconCheck } from './Icons'
import { cx } from './ui'
import { useToastList } from '../lib/toast'

const toasts = useToastList()
</script>

<template>
  <div aria-live="polite" class="pointer-events-none fixed bottom-5 right-5 z-50 flex flex-col gap-2">
    <div
      v-for="t in toasts"
      :key="t.id"
      :class="
        cx(
          'animate-in pointer-events-auto flex max-w-sm items-start gap-2.5 rounded-md border px-3 py-2.5 text-[13px] shadow-pop',
          t.tone === 'ok' ? 'border-ok/35 bg-panel text-text' : 'border-danger/40 bg-panel text-text',
        )
      "
    >
      <IconCheck v-if="t.tone === 'ok'" :size="15" class="mt-0.5 shrink-0 text-ok" />
      <IconAlert v-else :size="15" class="mt-0.5 shrink-0 text-danger" />
      <span class="break-words">{{ t.message }}</span>
    </div>
  </div>
</template>
